import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FascicleService } from '../services/fascicle.service';

export const FascicleNewResolver: ResolveFn<any> = async (route, state) => {
  const idCatalog = route.paramMap.get('idCatalog');
  try {
    return await inject(FascicleService).getBreadCrumbFascicleNew(idCatalog);
  } catch {
    return [];
  }
};
